import { 
  SiReact, SiTypescript, SiFramer, SiRedux, SiHtml5, SiCss3,
  SiNodedotjs, SiExpress,  SiMongodb, SiGraphql,
  SiGit, SiDocker, SiVercel, SiJest, SiWebpack, SiRedis, SiNpm
} from 'react-icons/si';
import { FiServer, FiSettings } from 'react-icons/fi';

export const skillsData = {
  heading: "Skills",
  categories: [
    {
      title: "Frontend",
      skills: [
        { name: "React", icon: SiReact },
        { name: "TypeScript", icon: SiTypescript },
        { name: "Framer Motion", icon: SiFramer },
        { name: "Redux", icon: SiRedux },
        { name: "HTML5", icon: SiHtml5 },
        { name: "CSS3", icon: SiCss3 }
      ]
    },
    {
      title: "Backend",
      skills: [
        { name: "Node.js", icon: SiNodedotjs },
        { name: "Express", icon: SiExpress },
        { name: "MongoDB", icon: SiMongodb },
        { name: "GraphQL", icon: SiGraphql },
        { name: "REST APIs", icon: FiServer },
        { name: "Redis", icon: SiRedis },
        { name: "NPM", icon: SiNpm }
      ]
    },
    {
      title: "Tools & Platforms",
      skills: [
        { name: "Git", icon: SiGit },
        { name: "Docker", icon: SiDocker },
        { name: "Vercel", icon: SiVercel },
        { name: "Jest", icon: SiJest },
        { name: "CI/CD", icon: FiSettings },
        { name: "Webpack", icon: SiWebpack }
      ]
    }
  ]
};
